import {
  TehnicalInspection,
  TehnicalInspectionEditFormValues,
  TehnicalInspectionRow,
} from "./types";
import {
  transformTehnicalInspection,
  transformTehnicalInspectionOnCreate,
  transformTehnicalInspectionOnUpdate,
  transformTehnicalInspectionRow,
} from "./transformations";
import { DataWithPagination } from "services/api/types";
import { Pagination } from "services/search";
import { createApiCall, paginatedApiCall } from "services/api/createApiCall";
import { transformErrorResponse } from "services/api/transformation";

/*---------------------------------------------------------------------------------------
  TEHNICAL INSPECTION SEARCH
-----------------------------------------------------------------------------------------*/

export const getTehnicalInspectionsAPI = async (
  pagination: Pagination,
  name?: string | null
): Promise<DataWithPagination<TehnicalInspectionRow>> => {
  let path = `/v1/expenses/mot?name=`;

  if (name) path += `${name}`;

  return await paginatedApiCall(
    path,
    pagination,
    transformTehnicalInspectionRow
  );
};

/*---------------------------------------------------------------------------------------
     TEHNICAL INSPECTION - BY ID
-----------------------------------------------------------------------------------------*/
export const getTehnicalInspectionAPI = async (
  id: string
): Promise<TehnicalInspection> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/mot/${id}`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformTehnicalInspection(response.data);
};

/*---------------------------------------------------------------------------------------
      TEHNICAL INSPECTION - CREATE
-----------------------------------------------------------------------------------------*/
export const createTehnicalInspectionAPI = async (
  formValues: TehnicalInspectionEditFormValues
): Promise<TehnicalInspection> => {
  const response = await createApiCall(
    {
      path: "/v1/expenses/mot/",
      method: "POST",
      body: transformTehnicalInspectionOnCreate(formValues),
    },
    {
      getMessage: {
        success: () => "Tehnički pregled je uspješno kreirana",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformTehnicalInspection(response.data);
};

/*---------------------------------------------------------------------------------------
      TEHNICAL INSPECTION - UPDATE
-----------------------------------------------------------------------------------------*/
export const updateTehnicalInspectionAPI = async (
  id: string,
  formValues: TehnicalInspectionEditFormValues
): Promise<TehnicalInspection> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/mot/${id}`,
      method: "PUT",
      body: transformTehnicalInspectionOnUpdate(formValues),
    },
    {
      getMessage: {
        success: () => "Tehnički pregled je uspješno ažuriran",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformTehnicalInspection(response.data);
};

/*---------------------------------------------------------------------------------------
     -  TEHNICAL INSPECTION - DELETE
-----------------------------------------------------------------------------------------*/
export const deleteTehnicalInspectionAPI = async (
  id: string
): Promise<TehnicalInspection> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/mot/${id}`,
      method: "DELETE",
    },
    {
      getMessage: {
        success: () => "Tehnički pregled je uspješno obrisana",
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return response.data;
};
